export const LANDING_BLOCK_MOBILE_WIDTH_THRESHOLD = 880;
